import { Field, Form, Formik } from "formik";
import Avatar from "pages/_components/Avatar";
import Button from "pages/_components/Button";
import CustomData from "pages/_components/CustomData/CustomData";
import { useParams } from "react-router-dom";
import CustomText from "pages/_components/CustomText/CustomText";
import TextField from "pages/_components/fields/TextField";
import GridTable from "pages/_components/GridTable/GridTable";
import { ResponsiveHeader } from "pages/_components/header";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import { bool } from "prop-types";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { actions as contactActions } from "reducers/contactDestination";
import I18n from "pages/_components/I18n";
import * as i18n from "util/i18n";
import * as Yup from "yup";

const FORM_ID = "frequentDestination.create";
const MIN_REQUIRED = "6";
const MAX_REQUIRED = "22";

const NewContactPage = (props) => {
    const dispatch = useDispatch();
    const { frequentDestination } = useSelector((state) => state.contactDestination);
    const { cbu } = useParams();

    const initialValues = {
        cbuAlias: (cbu || frequentDestination.cbu) ?? "",
        email: frequentDestination.recipientEmail ?? "",
        name: frequentDestination.name ?? "",
    };

    const handleSubmit = (values, formikBag) => {
        const newContactData = {
            cbu: values.cbuAlias,
            email: values.email,
            name: values.name,
        };
        dispatch(contactActions.frequentDestinationCreatePreview(newContactData, formikBag));
    };

    const isValidCbu = (value) => {
        const reg = /^\d+$/;
        return reg.test(value) && value.length === parseInt(MAX_REQUIRED, 10);
    };

    const isValidAlias = (value) => {
        /* Regex that accept letter from a to z including capital letters, (.), (-), numbers
        and excluding (Ñ) and (ñ) */
        const reg = /^(?:(?![ñÑ])[a-zA-Z.\-\d])+$/;
        return reg.test(value);
    };
    const validateCbuOrAlias = (value) => isValidCbu(value) || isValidAlias(value);

    const newContactSchema = Yup.object().shape({
        cbuAlias: Yup.string()
            .min(parseInt(MIN_REQUIRED, 10), `${i18n.get("forms.validation.min.required")} ${MIN_REQUIRED}`)
            .max(parseInt(MAX_REQUIRED, 10), `${i18n.get("forms.validation.max.required")} ${MAX_REQUIRED}`)
            .required(i18n.get(`global.error.required`))
            .test("format", i18n.get(`global.incorrect.format`), validateCbuOrAlias),

        email: Yup.string().email(i18n.get(`global.incorrect.format`)),
        name: Yup.string().required(i18n.get(`global.error.required`)),
    });

    const { isDesktop } = props;

    return (
        <>
            <Notification scopeToShow="FrequentDestinationsCreate" />
            <ResponsiveHeader id="transfer.contactDestination.title" />
            <MainContainer>
                <Formik initialValues={initialValues} onSubmit={handleSubmit} validationSchema={newContactSchema}>
                    {({ values, isSubmitting }) => (
                        <Form>
                            <GridTable className="form">
                                <GridTable.Container columns={12} rows={2} columnsTemplate="fixed">
                                    <GridTable.Data columnStart={2} columnWidth={5} rowStart={1}>
                                        <Field
                                            component={TextField}
                                            idForm={FORM_ID}
                                            name="cbuAlias"
                                            type="text"
                                            hidePlaceholder
                                        />
                                    </GridTable.Data>
                                    <GridTable.Data columnStart={7} columnWidth={5} rowStart={1}>
                                        <Field
                                            component={TextField}
                                            idForm={FORM_ID}
                                            name="email"
                                            type="email"
                                            hidePlaceholder
                                        />
                                    </GridTable.Data>
                                    <GridTable.Data columnStart={2} columnWidth={5} rowStart={2}>
                                        <Field
                                            component={TextField}
                                            idForm={FORM_ID}
                                            name="name"
                                            type="text"
                                            hidePlaceholder
                                        />
                                    </GridTable.Data>
                                </GridTable.Container>
                            </GridTable>
                            {/* <GridTable>
                                <GridTable.Container
                                    columns={isDesktop ? 12 : 1}
                                    rows={1}
                                    columnsTemplate="fixed"
                                    className="mt-6">
                                    <GridTable.Data
                                        columnStart={isDesktop ? 3 : 1}
                                        columnWidth={isDesktop ? 8 : 1}
                                        rowStart={1}>
                                        <GridTable>
                                            <GridTable.Container columns={2} rows={1} className="box box-shadow">
                                                <GridTable.Data columnStart={1} rowStart={1}>
                                                    <GridTable.Container columns={1} rows={1}>
                                                        <GridTable.Data rowStart={1} alignY="center">
                                                            <Avatar
                                                                user={{
                                                                    userFullName: values.name || "-",
                                                                    defaultAvatarId: 0,
                                                                    email: values.email,
                                                                }}
                                                            />
                                                            <CustomText
                                                                text={values.name || "-"}
                                                                textType="TEXT"
                                                                className="ml-3 my-auto add-new-contact"
                                                            />
                                                        </GridTable.Data>
                                                    </GridTable.Container>
                                                </GridTable.Data>
                                                <GridTable.Data
                                                    columnStart={isDesktop ? 2 : 1}
                                                    rowStart={isDesktop ? 1 : 2}>
                                                    <GridTable.Container columns={1} rows={2}>
                                                        <CustomData
                                                            titleText="debin.solicitDebin.creditAccountCbuNumber.label"
                                                            titleTextType="I18N"
                                                            titleClass="custom-data-title primary"
                                                            valueClass="custom-data-value primary"
                                                            valueText={values.cbuAlias || "-"}
                                                        />

                                                        {/* <GridTable.Data rowStart={2}>
                                                            <CustomText
                                                                className="data-label"
                                                                text={values.cbuAlias || "-"}
                                                            />
                                                        </GridTable.Data> */}
                                                    {/* </GridTable.Container>
                                                </GridTable.Data>
                                            </GridTable.Container>
                                        </GridTable> */}
                                    {/* </GridTable.Data>
                                </GridTable.Container>
                            </GridTable> */} 
                            <Row className="form-actions">
                                <Col xs={12} md={4} mdOffset={4}>
                                    <Button
                                        type="submit"
                                        loading={isSubmitting}
                                        className="btn-primary"
                                        label="global.continue"
                                        disabled={!values.cbuAlias || !values.name}
                                    />
                                </Col>
                            </Row>
                        </Form>
                    )}
                </Formik>
            </MainContainer>
        </>
    );
};
NewContactPage.propTypes = {
    isDesktop: bool.isRequired,
};

export default NewContactPage;
